import {FlexBox, useBreakpoint} from "@brg/ui";
import {VolumeOnIcon} from "../icons/VolumeOnIcon";
import {ProgressBarLine} from "./ProgressBarLine";
import {FC, RefObject, useEffect} from "react";
import {VolumeOffIcon} from "../icons/VolumeOffIcon";
import {useDispatch, useSelector} from "react-redux";
import {
    selectorAudioIsMuted,
    selectorAudioVolume, setAudioIsMuted,
    setAudioVolume
} from "../reducers/AudioSlice";
import {LayoutConst} from "../../../../core";

export const VolumeComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({ audioRef, hidden }) => {

    const volume = useSelector(selectorAudioVolume)
    const isSoundMuted = useSelector(selectorAudioIsMuted)
    const dispatch = useDispatch()
    const is992 = useBreakpoint(LayoutConst.screen.m);

    useEffect(() => {
        if (!audioRef?.current) return;
        audioRef.current.volume = isSoundMuted ? 0 : volume / 100
    }, [volume, audioRef, isSoundMuted])

    const onChangeVolume = (volume: number) => {
        dispatch(setAudioVolume(volume))
        if (isSoundMuted) dispatch(setAudioIsMuted(false))
    }

    return <FlexBox gx={16} align="center" style={{...(hidden || is992) && {display: "none"}}}>
        <div style={{ cursor: "pointer" }} onClick={() => dispatch(setAudioIsMuted(!isSoundMuted))}>{(volume === 0 || isSoundMuted) ? <VolumeOffIcon/> : <VolumeOnIcon/>}</div>
        <FlexBox width={160}>
            <ProgressBarLine value={isSoundMuted ? 0 : volume} onChange={onChangeVolume}/>
        </FlexBox>
    </FlexBox>
}import {FlexBox, useBreakpoint} from "@brg/ui";
import {VolumeOnIcon} from "../icons/VolumeOnIcon";
import {ProgressBarLine} from "./ProgressBarLine";
import {FC, RefObject, useEffect} from "react";
import {VolumeOffIcon} from "../icons/VolumeOffIcon";
import {useDispatch, useSelector} from "react-redux";
import {
    selectorAudioIsMuted,
    selectorAudioVolume, setAudioIsMuted,
    setAudioVolume
} from "../reducers/AudioSlice";
import {LayoutConst} from "../../../../core";

export const VolumeComponent: FC<{audioRef: RefObject<HTMLAudioElement>, hidden?: boolean}> = ({ audioRef, hidden }) => {

    const volume = useSelector(selectorAudioVolume)
    const isSoundMuted = useSelector(selectorAudioIsMuted)
    const dispatch = useDispatch()
    const is992 = useBreakpoint(LayoutConst.screen.m);

    useEffect(() => {
        if (!audioRef?.current) return;
        audioRef.current.volume = isSoundMuted ? 0 : volume / 100
    }, [volume, audioRef, isSoundMuted])

    const onChangeVolume = (volume: number) => {
        dispatch(setAudioVolume(volume))
        if (isSoundMuted) dispatch(setAudioIsMuted(false))
    }

    return <FlexBox gx={16} align="center" style={{...(hidden || is992) && {display: "none"}}}>
        <div style={{ cursor: "pointer" }} onClick={() => dispatch(setAudioIsMuted(!isSoundMuted))}>{(volume === 0 || isSoundMuted) ? <VolumeOffIcon/> : <VolumeOnIcon/>}</div>
        <FlexBox width={160}>
            <ProgressBarLine value={isSoundMuted ? 0 : volume} onChange={onChangeVolume}/>
        </FlexBox>
    </FlexBox>
}